module.exports = ".menu-button-footer {\n  position: absolute;\n  bottom: 2rem;\n  left: 0;\n  right: 0; }\n\n.sub-note {\n  opacity: .85;\n  font-weight: 200;\n  font-size: 1.1rem; }\n\n#file-input {\n  display: none; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/browse/browse.component.scss
// module id = ./src/app/components/browse/browse.component.scss
// module chunks = main